export * from 'src/app/@theme/layouts/admin/admin.component';
